import GenerateQuery from '../models/helpers/generateQuery.ts';
import { MeasurementUnit } from '../models/measurementUnits/measurementUnit.ts';
import { BaseSearchParam } from '../models/searchParams/baseSearchParam.ts';
import { TableSearchParam } from '../models/searchParams/tableSearchParam.ts';
import { ApiClient } from "./ApiClient.js";

const MeasurementUnitsController = {
    getAll: () => {
        let url = `measurementUnits`
        return ApiClient.get(url);
    },
    get: (tableSearchParam: TableSearchParam, baseSearchParam: BaseSearchParam) => {
        let url = `measurementUnits/${tableSearchParam.offset}/${tableSearchParam.limit}${GenerateQuery(baseSearchParam)}`;
        return ApiClient.get(url);
    },
    getByID: (id: number) => {
        return ApiClient.get(`measurementUnit/${id}`);
    },
    post: (measurementUnit: MeasurementUnit) => {
        return ApiClient.post('measurementUnit', measurementUnit);
    },
    put: (measurementUnit: MeasurementUnit) => {
        return ApiClient.put(`measurementUnit/${measurementUnit.measurementUnitID}`, measurementUnit);
    },
    delete: (id: number) => {
        return ApiClient.delete(`measurementUnit/${id}`)
    }
};
export default MeasurementUnitsController;